var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGithubLogo = function SvgGithubLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9 .222c-4.972 0-9 4.027-9 9a8.99 8.99 0 0 0 6.154 8.538c.45.08.619-.19.619-.427 0-.214-.012-.923-.012-1.676-2.261.416-2.846-.552-3.026-1.058-.101-.259-.54-1.057-.922-1.271-.316-.169-.766-.585-.012-.596.709-.012 1.215.652 1.384.922.81 1.361 2.104.979 2.621.743.079-.585.315-.98.574-1.204-2.002-.225-4.095-1.001-4.095-4.444 0-.979.349-1.789.922-2.419-.09-.225-.404-1.147.09-2.385 0 0 .754-.236 2.476.923a8.4 8.4 0 0 1 2.25-.304c.765 0 1.53.101 2.25.304 1.72-1.17 2.475-.923 2.475-.923.495 1.238.18 2.16.09 2.385.573.63.922 1.43.922 2.42 0 3.453-2.104 4.218-4.106 4.443.326.281.607.821.607 1.665 0 1.204-.011 2.171-.011 2.475 0 .236.169.517.619.427A9.01 9.01 0 0 0 18 9.222c0-4.973-4.027-9-9-9",
    clipRule: "evenodd"
  })));
};
export default SvgGithubLogo;